import guid from '@/lib/guid'
import {hydrate, create} from '@/models/chart'
export class Grid {
  constructor({
    id = null, name = null, layoutId = null, styles = [], icomponent =
      null,
      iproperties = null, x = 0, y = 0, w = 12, h = 15, neighbour = null, layers = []
  } = {}) {
    if (!id) {
      this.id = guid.createId('grid');
    } else {
      this.id = id;
    }



    if (!name) {
      this.name = 'Grid ' + this.id;
    }

    this.layoutId = layoutId;
    this.styles = styles;
    this.icomponent = icomponent;
    this.iproperties = iproperties;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this.i = this.id;
    this.active = false;

    if(layers && layers.length) {
      this.loadLayers(layers);
    } else {
      let layer = create({type: 'blank', name: 'Layer 1', typeGroup: 'chart'});
      layer.grid = this;
      this.layers = [
        layer
      ]
      // console.log('this.layers', this.layers);
    }

    // console.log("grid create");

    if (neighbour instanceof Grid) {
      this.x = neighbour.w + neighbour.x;
    }
  }
  loadLayers(layers) {
    this.layers = [];
    for(let i = 0; i < layers.length; i++) {
      try {
        // layer.setTree();
        let layer = hydrate(layers[i]);
        layer.grid = this;
        this.layers.push(layer);
      } catch(err) {
        console.log(err);
      }
    }

  }
  getApiInput(resetId) {
    let result = {
      layoutId: this.layoutId,
      name: this.name,
      styles: this.styles,
      icomponent: this.icomponent,
      iproperties: this.iproperties,
      x: this.x,
      y: this.y,
      w: this.w,
      h: this.h,
      i: this.i,
      active: this.active,
      layers: []
    }
    if(typeof this.id != "undefined") {
      result.id = this.id;
    }

    if(typeof resetId != "undefined" && resetId == true) {
      console.log("recreating grid id");
      result.id = guid.createId('grid');
    }

    Object.entries(this.layers).forEach(entry => {
      let key = entry[0];
      let item = entry[1];
      result.layers.push(item.getApiInput(resetId));
    });

    return result;
  }
}

export function createGrid(data) {
  return new Grid(data);
}
